import * as React from 'react';
import { connect } from 'react-redux';

import Page from 'components/page/Page';
import SidebarPage from 'components/page/sidebar-page/SidebarPage';
import InfluencerComposedMessage from 'components/influencer-composed-message/InfluencerComposedMessage';

import SettingsSidebar from 'modules/settings/SettingsSidebar';
import OrganizationBilling from '../../components/organization-billing/OrganizationBilling';

import {
  fetchInfluencerProfile,
  resetInfluencerProfile
} from 'modules/influencers/reducers/influencerProfile';

import { __t, applyTranslations } from 'utils/language';

import './organization-billing-page.scss';

applyTranslations('./organization-billing-page.i18n.json');

import { Organization } from 'types';

interface StateProps {
  profileId: number | null,
  currentOrganization: Organization
}

interface DispatchProps {
  onMount: (profileId: number) => void,
  onUnmount: () => void
}

type Props = StateProps & DispatchProps;

const OrganizationBillingPage = ({ profileId, currentOrganization, onMount, onUnmount }: Props) => {
  React.useEffect(() => {
    if (profileId === null) {
      return onUnmount;
    }

    onMount(profileId);

    return onUnmount;
  }, []);

  return (
    <Page documentTitle={__t('organization_billing_page.title')}>
      {profileId !== null && (
        <InfluencerComposedMessage
          ignoreIfPaymentDetailsPresent
          showButton={false}
          sidenoteClassName="organization-billing-page__sidenote"
        />
      )}
      <SidebarPage
        scrollable
        sidebarWidth="narrow"
        sidebarContent={<SettingsSidebar />}
      >
        <OrganizationBilling currentOrganization={currentOrganization} />
      </SidebarPage>
    </Page>
  );
};

const mapStateToProps = ({ organizations }): StateProps => ({
  profileId: (() => {
    const profile = (organizations?.currentOrganization?.influencerProfiles ?? [])[0] ?? null;

    return profile?.id ?? null;
  })(),
  currentOrganization: organizations.currentOrganization
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  onMount: (profileId) => {
    dispatch(fetchInfluencerProfile(profileId));
  },
  onUnmount: () => {
    dispatch(resetInfluencerProfile());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationBillingPage);
